{
	"cannotBeUndone": "This cannot be undone",
	"change": "Change",
	"currentTime": "Current Time",
	"day": "Day",
	"editProjectDate": "Edit Project Date",
	"hour": "Hour",
	"min": "Min",
	"mmmDYyyy": "MMM d, yyyy",
	"newTime": "New Time",
	"sec": "Sec",
	"title": "Adjust Capture Time"
}
